import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import '../static/less/layout/footer.less';

class Footer extends React.Component {
  constructor(props) {
    super(props);

    this.state = { year: new Date().getFullYear() };
  }

  render() {
    const { chainData, lang } = this.props;
    const termsUrl = this.props.chainData.booking_engine_configuration[`terms_and_conditions_url_${lang}`];
    return (
      <footer className="main-footer">
        <div className="main-footer-content text-center">
          <p className="footer-rights">
            © {this.state.year} {this.context.t('{chain} Hotels & Resorts. All rights reserved', { chain: chainData.name })} -&nbsp;
            <a href={termsUrl} target="_blank" rel="noreferrer">
              {this.context.t('Terms & Conditions')}
            </a>
          </p>
        </div>
      </footer>
    );
  }
}

Footer.propTypes = {
  lang: PropTypes.string.isRequired,
};

Footer.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect((state) => ({
  chainData: state.session.chainData,
}))(Footer);
